import React from "react";
import type { TCommunicationStatus } from "../helpers/communication-types-helper";
import { Localize } from "components/service";

interface ICommunicationStatusFieldProps {
  status: TCommunicationStatus;
}

const statusKeyMap: Record<TCommunicationStatus, string> = {
  pending: "COMMUNICATION.Status_Pending",
  unidentified: "COMMUNICATION.Status_Unidentified",
  approved: "COMMUNICATION.Status_Approved",
  dismissed: "COMMUNICATION.Status_Dismissed",
};

const CommunicationStatusField: React.FC<ICommunicationStatusFieldProps> = ({ status }) => (
  <span className={`communication-status-tag communication-status-tag--${status}`}>
    <Localize>{statusKeyMap[status]}</Localize>
  </span>
);

export default CommunicationStatusField;
